import styled, { css } from 'styled-components';

import { zIndexContentLayer2 } from '@xing-com/layout-tokens';
import { PopOver } from '@xing-com/pop-over';
import {
  scale005,
  scale340,
  scale410,
  spaceL,
  spaceM,
  xdlColorBorderSoft,
} from '@xing-com/tokens';

// *** Base ***
const baseMentionPopover = css`
  width: ${scale410};
`;

const baseInlinePopover = css`
  border-top: solid ${scale005} ${xdlColorBorderSoft};
`;

const basePopover = css`
  display: flex;
  flex-direction: column;
  max-height: ${scale340};
  overflow-x: hidden;
  padding: ${spaceM} ${spaceL};
  z-index: calc(${zIndexContentLayer2} + 1) !important;
`;

// *** Components ***

const MentionPopover = styled(PopOver)<{ $top?: string; $left?: string }>`
  ${basePopover}
  ${baseMentionPopover}
  ${({ $top }) => $top && `top: ${$top};`}
  ${({ $left }) => $left && `left: ${$left};`}
`;

const InlinePopOver = styled.div`
  ${basePopover}
  ${baseInlinePopover}
`;

export const Styled = {
  MentionPopover,
  InlinePopOver,
};
